/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { faSink } from '@fortawesome/free-solid-svg-icons/faSink'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useIntl } from 'react-intl'
import { parseNumber } from '@jalik/form-parser'
import FormNumberField, {
  FormNumberFieldProps
} from '../../../../client/js/components/form/fields/FormNumberField'

function KitchensField (props: FormNumberFieldProps) {
  const { name = 'kitchens', ...others } = props
  const intl = useIntl()
  return (
    <FormNumberField
      label={intl.formatMessage({
        id: 'kitchens',
        defaultMessage: 'Cuisines'
      })}
      name={name}
      parser={parseNumber}
      leftSection={(
        <FontAwesomeIcon
          fixedWidth
          icon={faSink}
        />
      )}
      {...others}
    />
  )
}

export default KitchensField
